//Old code ATC

setTimeout(() => {
  const productContainers = document.querySelectorAll('.product__thumbnail');
  const defaultQuantity = 1;

  productContainers.forEach((productContainer) => {
    const addToCartBtn = productContainer.querySelector('.add-to-cat-btn');
    const quantityPicker = productContainer.querySelector('.quantity-wrapper input[type="number"]');

    addToCartBtn.addEventListener('click', (event) => {
      event.preventDefault();
      const variantId = addToCartBtn.getAttribute('data-variant-id');
      const quantity = quantityPicker ? parseInt(quantityPicker.value) || defaultQuantity : defaultQuantity;
      const xhr = new XMLHttpRequest();
      xhr.open('POST', '/cart/add.js', true);
      xhr.setRequestHeader('Content-Type', 'application/json');
      xhr.onreadystatechange = () => {
        if (xhr.readyState === 4 && xhr.status === 200) {
          const res = JSON.parse(xhr.responseText);
          window.location.href = '/cart';
        }
      };

      const data = {
        id: variantId,
        quantity: quantity,
      };
      xhr.send(JSON.stringify(data));
    });
  });
}, 1500); 

//New code ATC

// var addToCartBtns = document.querySelectorAll('.add-to-cat-btn');

// addToCartBtns.forEach(function(addToCartBtn) {
//   addToCartBtn.addEventListener('click', function(event) {
//     event.preventDefault();
//     const defaultQuantity = 1;
//     const quantityPicker = addToCartBtn.querySelector('.quantity-wrapper input[type="number"]');
//     console.log("quantity",quantityPicker);

//     var variantId = addToCartBtn.getAttribute('data-variant-id');
//     console.log(variantId);
//     const quantity = quantityPicker ? parseInt(quantityPicker.value) || defaultQuantity : defaultQuantity;
//     console.log(quantity);

//     var xhr = new XMLHttpRequest();
//     xhr.open('POST', '/cart/add.js', true);
//     xhr.setRequestHeader('Content-Type', 'application/json');
//     xhr.onreadystatechange = function() {
//       if (xhr.readyState == 4 && xhr.status == 200) {
//         var res = JSON.parse(xhr.responseText);
//         window.location.href = '/cart';
//         // document.querySelector('#CartDrawer').classList.add('drawer--is-open');
//       }
//     };

//     var data = {
//       id: variantId,
//       quantity: quantity,
//     };
//     console.log(data);
//     // xhr.send(JSON.stringify(data));
//   }); 
// });
